import styled from 'styled-components';
import { colors } from '../../../styles/colors';

export const Styles = styled.div`
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 15px 20px 20px;
  h5.title {
    color: ${colors.black1};
    font-weight: 600;
    padding-bottom: 10px;
    margin-bottom: 20px;
    position: relative;
    &:before {
      position: absolute;
      content: '';
      background: ${colors.blue};
      width: 50px;
      height: 2px;
      bottom: 0;
      left: 0;
    }

    @media (max-width: 575px) {
      font-size: 17px;
    }
  }

  ul.feature-list {
    margin-bottom: 20px;
    li {
      border-top: 1px dashed ${colors.border3};
      padding: 12px 0;
      font-size: 14px;
      color: ${colors.black2};
      font-weight: 500;
      i {
        font-size: 20px;
        color: ${colors.blue};
        vertical-align: top;
        margin-right: 2px;
      }
      span {
        float: right;
        font-size: 13px;
        color: ${colors.text3};
        font-weight: 400;
        line-height: 20px;
      }
      &:first-child {
        border-top: none;
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 0;
      }
    }
  }

  button.enroll-btn {
    font-size: 16px;
    color: #fff;
    background: ${colors.grBg};
    display: inline-block;
    width: 100%;
    height: 40px;
    font-weight: 500;
    border: none;
    padding: 9px;
    border-radius: 5px;
    &:hover {
      background: ${colors.grBg2};
    }

    @media (max-width: 575px) {
      font-size: 14px;
    }
  }

  @media (max-width: 1199px) {
    padding: 12px 15px 15px;
  }
`;

export const CategoryStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  @media (max-width: 767px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;
